import React from "react";

export const FormActionsContainer = ({ record }) => {
  return <div className=""></div>;
};

export default FormActionsContainer;
